module.exports = __webpack_public_path__ + "img/PaymentEN.b5a56f06.png";